import React from "react"
import { Col, Row } from "react-bootstrap"

const NavegacionPasos = (props) => {
  return (
    <Row>
      <Col xs={12}>
        <div
          className={
            "process-wrap active-step" +
            (props.pasos.indexOf(
              props.pasos.find((p) => p.id === props.pasoactualid)
            ) +
              1)
          }
        >
          <div className="process-main">
            {props.pasos.map((paso, idx) => (
              <div className="col-edit-3 " key={idx}>
                <div className="process-step-cont">
                  <div className={"process-step step-" + (idx + 1)}></div>
                  <span className="process-label">{paso.title}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </Col>
    </Row>
  )
}

export default NavegacionPasos
